import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import {Observable} from 'rxjs';
import {AppStateService} from "../../services/appstate/app.state.service";
import {Injectable} from "@angular/core";
import {CustomRouterService} from "../../services/custom-router.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private readonly appState: AppStateService, private readonly router: Router, private readonly customRouterService: CustomRouterService, ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.appState.user.isUserAuthenticated) {
      return true;
    } else {
      if (this.appState.isBrowser) {
        this.appState.lastActionUrl = state.url;
        this.customRouterService.goToPage('auth/login');
      }
      return false;
    }
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.appState.user.isUserAuthenticated) {
      return true;
    } else {
      if (this.appState.isBrowser) {
        this.appState.lastActionUrl = state.url;
        this.customRouterService.goToPage('auth/login');
      }
      return false;
    }
  }
}
